/**
 * Safe custom element decorator that only registers if not already registered.
 * This prevents "CustomElementRegistry already defined" errors when components
 * are imported multiple times (e.g., in Storybook).
 */
export function safeCustomElement(tagName: string) {
  return <T extends CustomElementConstructor>(
    ctor: T,
    context?: ClassDecoratorContext
  ): T | undefined => {
    // Check if the element is already defined
    if (!customElements.get(tagName)) {
      customElements.define(tagName, ctor)
    }

    // Return for TypeScript 5.0+ decorator compatibility
    if (context) {
      return
    }
    return ctor
  }
}
